import React from 'react'
import { Initial } from 'react-initial'
import i18n from 'i18n'

import { getAvatarURL } from 'pages/records/components/helper'

import styles from './style.module.scss'

const GroupMemberPopup = ({ members = [], orgChartData }) => {
  if (members.length === 0) {
    return <div className={styles.emptyState}>{i18n.t('menu.noGroupMembers')}</div>
  }

  const sortedMembers = [...members].sort((a, b) => {
    if (a.is_admin === b.is_admin) return 0
    return a.is_admin ? -1 : 1
  })

  return (
    <div className={styles.container}>
      <div className={styles.memberList}>
        {sortedMembers.map((member) => {
          const name = member.user_name || member.name || ''
          const email = member.user_email || member.email || ''
          const avatarUrl = member.avatar_url || getAvatarURL(name, email, orgChartData)

          return (
            <div key={member.id} className={styles.memberItem}>
              <div className={styles.profileImage}>
                {avatarUrl ? (
                  <img src={avatarUrl} alt={name} />
                ) : (
                  <Initial name={name || email} fontSize={18} height={48} width={48} />
                )}
              </div>
              <div className={styles.memberInfo}>
                <div className={styles.nameRow}>
                  <span className={styles.memberName}>{name || email}</span>
                  {member.is_admin && <span className={styles.adminBadge}>Admin</span>}
                </div>
                {email && <span className={styles.memberEmail}>{email}</span>}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default GroupMemberPopup
